import { render, staticRenderFns } from "./GroupProduct.vue?vue&type=template&id=6b993a14&"
import script from "./GroupProduct.vue?vue&type=script&lang=js&"
export * from "./GroupProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports